import { memo } from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ShowMultiItems = ({ items, text, useStyledTypography = true }) => {
  const { t } = useTranslation();
  const getItemLabel = (item) =>
    item?.labelKey ? t(item.labelKey) : item?.name ?? "—";
  const itemsArray = Array.isArray(items) ? items : [];
  const firstItem = getItemLabel(itemsArray[0]);
  const remainingItems = itemsArray.slice(1);

  const firstItemContent = useStyledTypography ? (
    <Typography
      component="span"
      sx={{
        color: "text.primary",
        fontSize: "0.8125rem",
        fontWeight: 600,
        lineHeight: 1.3,
      }}
    >
      {firstItem}
    </Typography>
  ) : (
    firstItem
  );

  return (
    <Typography
      variant="body2"
      color={useStyledTypography ? "text.secondary" : "text.primary"}
      component="div"
      sx={{ lineHeight: 1.45 }}
    >
      {text && <Box component="span" sx={{ opacity: 0.72 }}>{`${text}: `}</Box>}
      {firstItemContent}
      {remainingItems.length > 0 && (
        <Tooltip
          title={
            <div>
              {remainingItems.map((item) => (
                <div key={item._id}>{getItemLabel(item)}</div>
              ))}
            </div>
          }
          arrow
        >
          <Chip
            size="small"
            label={`+${remainingItems.length}`}
            color="default"
            sx={{ ml: 0.5, borderRadius: "50%" }}
          />
        </Tooltip>
      )}
    </Typography>
  );
};

export default memo(ShowMultiItems);
